module.exports = __webpack_public_path__ + "static/media/site-large.31e1014f.webp";